/* Livechat op de winkel, met de AI-bot (20-10-2026). Praat met Frontrun
   /chat/bericht en /chat/gesprek (web/chat.mjs); de eigenaar leest mee en
   neemt over op /chat.

   Herbouwd op 20-10: de vorige versie (branch chat-avatars, 3d9dcb0, alleen op
   zijn PC) stond in geen enkel Shopify-thema meer. Deze kopie staat daarom ook
   in de Frontrun-repo onder winkelthema/.

   DE AVATAR ANTWOORDT (21-10, zijn regels). Alles start pas na het laden van
   de pagina; knop op 10 s, op mobiel alleen een gezicht met een groen bolletje.
   Een vraag toont "Waiting for Sophie to join..." (de naam wisselt elke 2 s)
   met "You're next in line" tot de avatar na circa 30 s binnenkomt ("Amara
   joined the chat") met een welkom; daarna leest en typt hij in menselijk
   tempo (server.mjs). Kop: naam + "Draycott customer care".

   Netwerk: een statusvraag bij het laden, daarna elke 60 s (zonder gesprek)
   of 30 s (met gesprek) zolang het tabblad zichtbaar is; met het paneel open
   elke 3 s, en 1,5 s terwijl de avatar typt. Geen chat op checkout, account
   en orders. */
(function () {
  var BASIS = 'https://frontrun.tristanzoethout.nl';
  if (/^\/(checkouts|account|orders)(\/|$)/.test(location.pathname) || window.draycottChat) return;
  window.draycottChat = true;

  // Een .js-asset kent geen Liquid: de map van de foto's komt uit de eigen URL.
  var src = (document.currentScript && document.currentScript.src) || '';
  var MAP = src.split('?')[0].replace(/[^/]*$/, '');
  var foto = function (f) { return MAP + 'draycott-chat-team-' + f + '.jpg'; };
  var VOORZET = [{ naam: 'Sophie', foto: 'vrouw-headset' }, { naam: 'James', foto: 'man-headset' },
    { naam: 'Amara', foto: 'vrouw-krullen-headset' }];
  // Op een productpagina direct (de bezoeker komt met een vraag), elders na 10 s (21-10).
  var TOON_NA_MS = /\/products\//.test(location.pathname) ? 0 : 10000;
  var EMAIL_RE = /[^\s@]{1,100}@[^\s@.]+(\.[^\s@.]+)+/;

  var opslag = function (s, k, v) {
    try { if (v === undefined) return window[s].getItem(k); if (v === null) window[s].removeItem(k); else window[s].setItem(k, v); }
    catch (e) { return null; }
  };
  var id = opslag('localStorage', 'draycott-chat-id');
  var na = 0, berichten = [], open = false, timer = null, bezig = false;
  var st = { online: false, team: null, ai: false, avatar: null, mens: false, typt: null, joined: false };
  try { var oud = JSON.parse(opslag('sessionStorage', 'draycott-chat-online') || 'null');
    if (oud && Date.now() - oud.t < 60000) { st.online = oud.online; st.team = oud.team; st.ai = oud.ai; } } catch (e) {}

  function nieuwId() {
    var a = new Uint8Array(12); (window.crypto || window.msCrypto).getRandomValues(a);
    return 'w' + Array.prototype.map.call(a, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
  }
  function bezoeker() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      if (!(p && p.analyticsProcessingAllowed && p.analyticsProcessingAllowed())) return null;
      return window.ShopifyAnalytics.lib.user().traits().uniqToken || null;
    } catch (e) { return null; }
  }
  /* A/B-TEST 30 SECONDEN (23-10, zijn vraag). Elke browser valt vast in één
     groep: `tijd` krijgt na 30 s op de site een wolkje, `controle` niet. Vast
     per browser en niet per paginabezoek, anders ziet dezelfde koper beide
     varianten en zegt de uitkomst niets. Alle andere triggers blijven in beide
     groepen gelijk. De groep gaat mee met elke meting; /chat zet ze naast elkaar. */
  var AB = opslag('localStorage', 'draycott-chat-ab');
  if (AB !== 'tijd' && AB !== 'controle') {
    AB = Math.random() < 0.5 ? 'tijd' : 'controle';
    opslag('localStorage', 'draycott-chat-ab', AB);
  }
  /* Meting voor de cijfers op /chat: getoond, geopend en bericht, elk hooguit
     een keer per paginabezoek. Shopify's id alleen met analytics-toestemming. */
  var gemeten = {};
  function meet(soort, trigger) {
    if (gemeten[soort] || !navigator.sendBeacon) return;
    gemeten[soort] = true;
    var d = { soort: soort, pad: location.pathname.slice(0, 300), ab: AB };
    if (trigger) d.trigger = trigger;
    try { d.tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
    var bz = bezoeker(); if (bz) d.id = bz;
    try { navigator.sendBeacon(BASIS + '/bezoek/chat', JSON.stringify(d)); } catch (e) {}
  }
  function el(tag, cls, tekst) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (tekst != null) e.textContent = tekst;
    return e;
  }
  function gezicht(f, cls) {
    var i = el('img', cls); i.src = foto(f); i.alt = ''; i.width = 48; i.height = 48; i.decoding = 'async';
    return i;
  }

  /* ---- CSS ---------------------------------------------------------------- */
  var css = el('style');
  css.textContent = [
    '.dc-knop{position:fixed;right:16px;bottom:calc(16px + var(--dc-onder,0px));z-index:5600;display:flex;align-items:center;gap:10px;',
    'padding:6px 16px 6px 6px;border:0;border-radius:999px;background:#111;color:#fff;font:inherit;font-size:14px;cursor:pointer;',
    'box-shadow:0 6px 24px rgba(0,0,0,.18);transition:padding .2s,bottom .2s}',
    '.dc-knop:focus-visible{outline:2px solid #111;outline-offset:3px}',
    '.dc-gezichten{display:flex}.dc-gezichten img{width:34px;height:34px;border-radius:50%;border:2px solid #111;object-fit:cover;background:#ddd}',
    '.dc-gezichten img+img{margin-left:-12px}',
    '.dc-tekst{display:flex;flex-direction:column;align-items:center;line-height:1.15;white-space:nowrap}',
    '.dc-live{font-size:11px;opacity:.85;display:flex;align-items:center;gap:4px}.dc-live[hidden]{display:none}',
    '.dc-live i{width:7px;height:7px;border-radius:50%;background:#3ccf6b;display:inline-block}',
    '.dc-klein{padding:6px}.dc-klein .dc-tekst{display:none}',
    'html[data-scroll-locked] .dc-knop,html.dc-open .dc-knop{display:none}',
    '.dc-knop{opacity:0;transform:translateY(12px);pointer-events:none;transition:opacity .35s,transform .35s,padding .2s,bottom .2s}',
    '.dc-knop.dc-toon{opacity:1;transform:none;pointer-events:auto}',
    // Het online-bolletje staat op alle breedtes rechtsonder op het laatste gezicht (op desktop eerst alleen mobiel).
    '.dc-gezichten{position:relative}',
    '.dc-stip{display:block;position:absolute;right:0;bottom:0;width:12px;height:12px;border-radius:50%;background:#3ccf6b;border:2px solid #fff}',
    '.dc-stip[hidden]{display:none}',
    '.dc-systeem{align-self:center;font-size:12px;color:#777;text-align:center}',
    '.dc-wachten{display:flex;gap:10px;align-items:center;align-self:center;font-size:13px;color:#666}',
    '.dc-wachten span{display:flex;flex-direction:column}.dc-wachten .dc-wachtregel{display:block}.dc-wachten b{font-weight:600;color:#333}',
    '.dc-wachten small{font-size:12px;color:#888;margin-top:2px}',
    '.dc-wachten i{width:14px;height:14px;border:2px solid #ccc;border-top-color:#111;border-radius:50%;animation:dc-draai 1s linear infinite}',
    '@keyframes dc-draai{to{transform:rotate(360deg)}}',
    '@media (prefers-reduced-motion:reduce){.dc-wachten i{animation:none}}',
    /* Mobiel: alleen een gezicht met een groen bolletje, zodat de knop niets van de pagina bedekt. */
    '@media (max-width:640px){.dc-knop{right:12px;bottom:calc(12px + var(--dc-onder,0px));padding:0;background:none;box-shadow:none}',
    '.dc-knop .dc-tekst{display:none}.dc-knop .dc-gezichten img{width:46px;height:46px;border:2px solid #fff;box-shadow:0 4px 14px rgba(0,0,0,.22)}',
    '.dc-knop .dc-gezichten img+img{display:none}',
    '.dc-stip{display:block;position:absolute;right:1px;bottom:1px;width:12px;height:12px;border-radius:50%;background:#3ccf6b;border:2px solid #fff}',
    '.dc-stip[hidden]{display:none}}',
    /* Het wolkje van een trigger: boven de knop, klein, met een kruisje. Hoog in de
       stapel, want de maatgids en de maatkiezer liggen zelf als laag over de pagina. */
    '.dc-wolk{position:fixed;right:16px;bottom:calc(76px + var(--dc-onder,0px));z-index:2147483000;display:flex;align-items:flex-start;gap:8px;',
    'width:min(300px,calc(100vw - 32px));padding:10px 8px 10px 10px;background:#fff;color:#111;border-radius:14px;',
    'box-shadow:0 8px 28px rgba(0,0,0,.22);font:inherit;font-size:14px;line-height:1.35;animation:dc-in .3s ease-out}',
    '.dc-wolk[hidden]{display:none}',
    '.dc-wolk-open{flex:1;display:flex;gap:10px;align-items:flex-start;border:0;background:none;padding:0;text-align:left;font:inherit;color:inherit;cursor:pointer}',
    '.dc-wolk-open img{width:36px;height:36px;border-radius:50%;object-fit:cover;flex:none;background:#ddd}',
    '.dc-wolk-open b{display:block;font-size:12px;color:#666;font-weight:600;margin-bottom:2px}',
    '.dc-wolk-dicht{border:0;background:none;font-size:20px;line-height:1;padding:0 4px;cursor:pointer;color:#888}',
    '@keyframes dc-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}',
    '@media (prefers-reduced-motion:reduce){.dc-wolk{animation:none}}',
    '@media (max-width:640px){.dc-wolk{right:12px;bottom:calc(66px + var(--dc-onder,0px));width:min(300px,calc(100vw - 24px))}}',
    /* Bij de maatkiezer: bovenaan, want de sheet staat onderin en de maatknoppen mogen niet bedekt worden. */
    '.dc-wolk.dc-wolk-boven{top:16px;bottom:auto;right:12px;left:auto}',
    '.dc-paneel{position:fixed;right:16px;bottom:16px;z-index:5700;width:360px;height:min(540px,calc(100vh - 32px));display:flex;flex-direction:column;',
    'background:#fff;color:#111;border-radius:14px;box-shadow:0 12px 40px rgba(0,0,0,.22);overflow:hidden;font:inherit;font-size:15px}',
    '.dc-paneel[hidden]{display:none}',
    '.dc-kop{display:flex;align-items:center;gap:10px;padding:12px 12px 12px 14px;border-bottom:1px solid #eee}',
    '.dc-kop .dc-gezichten img{border-color:#fff;width:38px;height:38px}',
    '.dc-kopfoto{position:relative;display:flex;flex:none}',
    '.dc-kopstip{position:absolute;right:0;bottom:0;width:11px;height:11px;border-radius:50%;background:#3ccf6b;border:2px solid #fff}',
    '.dc-kopstip[hidden]{display:none}',
    '.dc-wie{flex:1;min-width:0;display:flex;flex-direction:column}.dc-wie strong{font-size:15px}',
    '.dc-sub{font-size:12px;color:#666}',
    '.dc-dicht{border:0;background:none;font-size:26px;line-height:1;padding:4px 8px;cursor:pointer;color:#111}',
    '.dc-lijst{flex:1;overflow-y:auto;overflow-x:hidden;padding:14px;display:flex;flex-direction:column;gap:10px;overscroll-behavior:contain}',
    '.dc-intro{font-size:13px;color:#666;text-align:center;margin:4px 8px 6px}',
    '.dc-rij{display:flex;gap:8px;align-items:flex-end;max-width:88%;min-width:0}.dc-rij>div{min-width:0}',
    '.dc-rij img{width:28px;height:28px;border-radius:50%;object-fit:cover;flex:none;background:#ddd}',
    '.dc-bel{padding:9px 12px;border-radius:14px;background:#f2f2f2;white-space:pre-wrap;overflow-wrap:anywhere;line-height:1.4}',
    '.dc-bel strong{font-weight:700}',
    /* Productkaart onder een antwoord: foto, naam, prijs en View. */
    '.dc-kaart{display:flex;gap:10px;align-items:center;margin-top:6px;padding:8px;border:1px solid #e5e5e5;border-radius:12px;background:#fff;',
    'color:#111;text-decoration:none;max-width:280px}',
    '.dc-kaart img{width:56px;height:70px;object-fit:cover;border-radius:6px;background:#eee;flex:none}',
    '.dc-kaart-tekst{flex:1;min-width:0;font-size:13px;line-height:1.3}',
    '.dc-kaart-tekst b{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-weight:600}',
    '.dc-kaart-tekst span{display:block;color:#555;margin-top:2px}',
    '.dc-kaart-knop{flex:none;background:#111;color:#fff;border-radius:8px;padding:7px 12px;font-size:12px;font-weight:600}',
    /* In de tas (22-10): de kaart is een blok met de link en een rij met maat en knop. */
    '.dc-kaart--koop{display:block;padding:8px}.dc-kaart-link{display:flex;gap:12px;align-items:center;color:inherit;text-decoration:none}',
    '.dc-kaart--koop img{width:80px;height:100px}.dc-kaart-tekst small{display:block;color:#777;font-size:11px;margin-top:4px}',
    '.dc-koop{display:flex;gap:6px;margin-top:8px}.dc-koop select{flex:1;min-width:0;font:inherit;font-size:13px;padding:6px;border:1px solid #ccc;border-radius:8px;background:#fff;color:#111}',
    '.dc-koop button{flex:none;border:0;background:#111;color:#fff;border-radius:8px;padding:7px 12px;font:inherit;font-size:12px;font-weight:600;cursor:pointer}',
    '.dc-koop button:disabled{background:#2e7d32;cursor:default}',
    // Remove op de kaart: rustiger dan Add to bag, zodat het geen tweede hoofdknop is.
    '.dc-koop button.dc-weg{background:#fff;color:#111;border:1px solid #111}',
    '.dc-intas{display:flex;gap:8px;align-items:center;margin-top:6px;font-size:12px;color:#2e7d32}',
    // Tikvlak van minstens 36 px: een onderstreept woord was op een telefoon niet te raken.
    '.dc-intas button{min-height:36px;padding:0 14px;border:1px solid #bbb;border-radius:8px;background:#fff;font:inherit;color:#111;cursor:pointer}',
    '.dc-van{display:block;font-size:11px;color:#777;margin:0 0 3px 2px}',
    '.dc-rij--klant{align-self:flex-end}.dc-rij--klant .dc-bel{background:#111;color:#fff}',
    '.dc-rij--wacht .dc-bel{opacity:.6}',
    '.dc-typt{display:flex;gap:8px;align-items:center;font-size:13px;color:#666;padding:0 14px 8px}.dc-typt[hidden]{display:none}',
    '.dc-typt img{width:22px;height:22px;border-radius:50%;object-fit:cover}',
    '.dc-vak{display:flex;flex-direction:column;gap:8px;padding:10px 12px;border-top:1px solid #eee}',
    '.dc-regel{display:flex;gap:8px;align-items:flex-end}',
    '.dc-vak textarea,.dc-vak input{flex:1;font:inherit;font-size:16px;padding:9px 11px;border:1px solid #ccc;border-radius:10px;resize:none;min-width:0;color:#111;background:#fff}',
    '.dc-vak input[hidden]{display:none}',
    '.dc-stuur{border:0;border-radius:10px;background:#111;color:#fff;font:inherit;font-size:14px;padding:10px 14px;cursor:pointer}',
    '.dc-stuur:disabled{opacity:.4;cursor:default}',
    '.dc-melding{font-size:12px;color:#a33;margin:0}.dc-melding:empty{display:none}',
    '@media (max-width:640px){.dc-paneel{right:0;bottom:auto;top:0;width:100%;height:100%;border-radius:0}',
    'html.dc-open,html.dc-open body{overflow:hidden}}'
  ].join('');

  /* ---- knop --------------------------------------------------------------- */
  var knop = el('button', 'dc-knop');
  knop.type = 'button';
  knop.setAttribute('aria-label', 'Chat with Draycott');
  var knopGezichten = el('span', 'dc-gezichten');
  var tekst = el('span', 'dc-tekst', 'Get advice');
  var live = el('small', 'dc-live');
  live.appendChild(el('i'));
  live.appendChild(document.createTextNode('Live now'));
  tekst.appendChild(live);
  var stip = el('span', 'dc-stip');
  knopGezichten.appendChild(stip);
  knop.appendChild(knopGezichten);
  knop.appendChild(tekst);

  /* ---- paneel ------------------------------------------------------------- */
  var paneel = el('div', 'dc-paneel');
  paneel.hidden = true;
  paneel.setAttribute('role', 'dialog');
  paneel.setAttribute('aria-label', 'Chat with Draycott');
  var kop = el('div', 'dc-kop');
  var kopGezichten = el('span', 'dc-gezichten');
  // Het bolletje staat naast de gezichten en niet erin: vulGezichten() maakt die leeg.
  var kopFoto = el('span', 'dc-kopfoto');
  var kopStip = el('span', 'dc-kopstip');
  kopFoto.appendChild(kopGezichten); kopFoto.appendChild(kopStip);
  var wie = el('div', 'dc-wie');
  var naamEl = el('strong');
  var sub = el('span', 'dc-sub');
  wie.appendChild(naamEl); wie.appendChild(sub);
  var dicht = el('button', 'dc-dicht', '\u00d7');
  dicht.type = 'button'; dicht.setAttribute('aria-label', 'Close chat');
  kop.appendChild(kopFoto); kop.appendChild(wie); kop.appendChild(dicht);
  var lijst = el('div', 'dc-lijst');
  lijst.setAttribute('aria-live', 'polite');
  var typt = el('div', 'dc-typt'); typt.hidden = true;
  var vak = el('form', 'dc-vak');
  var email = el('input'); email.type = 'email'; email.placeholder = 'Your email, so we can reply'; email.autocomplete = 'email'; email.hidden = true;
  var regel = el('div', 'dc-regel');
  var veld = el('textarea'); veld.rows = 1; veld.maxLength = 1000; veld.placeholder = 'Ask about sizing, delivery, returns...';
  veld.setAttribute('aria-label', 'Your message');
  var stuurKnop = el('button', 'dc-stuur', 'Send'); stuurKnop.type = 'submit'; stuurKnop.disabled = true;
  var melding = el('p', 'dc-melding');
  regel.appendChild(veld); regel.appendChild(stuurKnop);
  vak.appendChild(email); vak.appendChild(regel); vak.appendChild(melding);
  paneel.appendChild(kop); paneel.appendChild(lijst); paneel.appendChild(typt); paneel.appendChild(vak);

  /* ---- tekenen ------------------------------------------------------------ */
  function team() { return (st.team && st.team.length ? st.team : VOORZET).slice(0, 3); }
  function vulGezichten(doel, wie) {
    doel.textContent = '';
    wie.forEach(function (t) { doel.appendChild(gezicht(t.foto)); });
  }
  function namen(t) {
    var n = t.map(function (x) { return x.naam; });
    return n.length > 1 ? n.slice(0, -1).join(', ') + ' & ' + n[n.length - 1] : n[0];
  }
  function tekenKnop() {
    vulGezichten(knopGezichten, team());
    knopGezichten.appendChild(stip); // vulGezichten leegt de groep; het bolletje hoort erin
    live.hidden = stip.hidden = !st.online;
  }
  function tekenKop() {
    var binnen = st.avatar && st.joined;
    var wie = binnen ? [st.avatar] : team();
    vulGezichten(kopGezichten, wie);
    naamEl.textContent = binnen ? st.avatar.naam : 'Draycott';
    kopStip.hidden = !(binnen || st.online);
    sub.textContent = binnen ? 'Draycott customer care'
      : st.online ? 'Online now' : 'We reply by email';
    email.hidden = st.ai || st.online || !!opslag('localStorage', 'draycott-chat-email');
  }
  /* Alleen opnieuw opbouwen als er iets veranderde: de poll komt elke seconde,
     en een nieuw opgebouwde lijst liet het wachtrondje steeds opnieuw beginnen. */
  var getekend = '';
  function tekenLijst() {
    var stand = JSON.stringify([berichten.map(function (b) { return [b.n, b.wacht, b.tekst.length]; }), st.typt, st.joined, st.mens, st.avatar, st.online, inTas]);
    if (stand === getekend) return;
    getekend = stand;
    var onder = lijst.scrollHeight - lijst.scrollTop - lijst.clientHeight < 80;
    lijst.textContent = '';
    // Geen AI-vermelding meer in de widget (zijn keuze 21-10); op een oprechte vraag zegt de bot het zelf.
    lijst.appendChild(el('p', 'dc-intro', 'Questions about sizing, delivery or returns? Send us a message.'));
    var gemeld = false;
    berichten.forEach(function (b) {
      if (b.van === 'systeem') { gemeld = false; lijst.appendChild(el('p', 'dc-systeem', b.tekst)); return; }
      var klant = b.van === 'klant';
      if (!klant && !gemeld && (b.naam || st.avatar)) { gemeld = true; lijst.appendChild(el('p', 'dc-systeem', (b.naam || st.avatar.naam) + ' joined the chat')); }
      var rij = el('div', 'dc-rij dc-rij--' + (klant ? 'klant' : 'team') + (b.wacht ? ' dc-rij--wacht' : ''));
      var blok = el('div');
      if (!klant) {
        rij.appendChild(gezicht(b.foto || (st.avatar && st.avatar.foto) || 'vrouw-headset'));
        blok.appendChild(el('span', 'dc-van', b.naam || (st.avatar && st.avatar.naam) || 'Draycott'));
      }
      if (klant) { blok.appendChild(el('div', 'dc-bel', b.tekst)); }
      else {
        /* Productlinks worden kaarten (foto, naam, prijs, View) en verdwijnen uit
           de tekst; een lange URL duwde het paneel opzij. **x** = vet. */
        var handles = [], kleuren = {};
        var schoon = b.tekst.replace(PRODUCT_RE, function (m, h, rest) {
          if (handles.indexOf(h) < 0) handles.push(h);
          var k = /[?&]colou?r=([^&#]+)/i.exec(rest || '');
          if (k) { try { kleuren[h] = decodeURIComponent(k[1].replace(/\+/g, ' ')); } catch (e) {} }
          return '';
        })
          .replace(/\(\s*\)|[ \t]*:\s*$/gm, '').replace(/\n{3,}/g, '\n\n').trim();
        var bel = el('div', 'dc-bel'); metOpmaak(bel, schoon); if (schoon) blok.appendChild(bel);
        if (b.tas && inTas[b.n]) blok.appendChild(tasRegel(b.n));
        if (b.tasWeg && haalWegGedaan(b.n)) blok.appendChild(el('div', 'dc-intas', 'Removed from your bag.'));
        handles.slice(0, 3).forEach(function (h) { blok.appendChild(kaart(h, kleuren[h])); });
      }
      rij.appendChild(blok);
      lijst.appendChild(rij);
    });
    // Wel een vraag gesteld, nog niemand binnen: wachten op een medewerker.
    clearInterval(wachtNaamTimer);
    if (offlineVraag()) lijst.appendChild(el('p', 'dc-systeem', 'We\u2019re offline right now' + (st.tijden ? ' (live ' + st.tijden + ' UK time)' : '') +
      // Met een bekend mailadres is het e-mailveld weg; "above" zou dan naar niets wijzen.
      (opslag('localStorage', 'draycott-chat-email') ? '. We\u2019ll get back to you by email.' : '. Leave your email above and we\u2019ll get back to you.')));
    if (wachtOpAgent()) {
      var w = el('div', 'dc-wachten'); w.appendChild(el('i'));
      // "Waiting for Sophie to join...": de naam wisselt elke 2 s door het team.
      var namenLijst = team().map(function (x) { return x.naam; }), ni = 0;
      var wn = el('b', 'dc-wachtnaam', namenLijst[0]);
      var wt = el('span'), wr = el('span', 'dc-wachtregel');
      wr.appendChild(document.createTextNode('Waiting for ')); wr.appendChild(wn); wr.appendChild(document.createTextNode(' to join...'));
      wt.appendChild(wr);
      if (namenLijst.length > 1) wachtNaamTimer = setInterval(function () { ni = (ni + 1) % namenLijst.length; wn.textContent = namenLijst[ni]; }, 2000);
      wt.appendChild(el('small', null, 'You\u2019re next in line \u00b7 approx. 30\u201360 sec wait'));
      w.appendChild(wt); lijst.appendChild(w);
    }
    typt.textContent = '';
    typt.hidden = !st.typt;
    if (st.typt && st.avatar) { typt.appendChild(gezicht(st.avatar.foto)); typt.appendChild(document.createTextNode(st.typt + ' is typing...')); }
    if (onder) lijst.scrollTop = lijst.scrollHeight;
  }

  var wachtNaamTimer = null;
  // Met een eventuele ":" ervoor, zodat er geen losse dubbele punt achterblijft.
  var PRODUCT_RE = /[ \t]*:?[ \t]*https?:\/\/(?:www\.)?draycottclothing\.co\.uk\/products\/([a-z0-9-]+)([^\s)]*)/gi;
  function metOpmaak(doel, tekst) {
    tekst.split(/(\*\*[^*\n]+\*\*)/).forEach(function (deel) {
      if (/^\*\*[^*\n]+\*\*$/.test(deel)) doel.appendChild(el('strong', null, deel.slice(2, -2)));
      else if (deel) doel.appendChild(document.createTextNode(deel));
    });
  }
  /* De kaart staat er meteen (naam uit de handle) en vult zich met foto en prijs
     uit /products/<handle>.js; per handle een keer opgehaald. */
  var producten = {};
  /* Kleur uit de link van de bot (?colour=Navy, 22-10): de kaart toont dan die
     kleur, met haar foto, haar maten en een link naar die variant. Zonder of
     met een kleur die op is: de eerste leverbare kleur. */
  function kleurPlek(p) {
    var namen = (p.options || []).map(function (o) { return String(o && o.name || o).toLowerCase(); });
    return Math.max(namen.indexOf('colour'), namen.indexOf('color')) + 1;
  }
  function kleurVan(p, kleur) {
    var plek = kleurPlek(p), lever = (p.variants || []).filter(function (v) { return v.available; });
    if (!plek || !lever.length) return null;
    var k = String(kleur || '').toLowerCase();
    var raak = lever.filter(function (v) { return String(v['option' + plek]).toLowerCase() === k; })[0];
    return (raak || lever[0])['option' + plek];
  }
  /* Korte naam (zijn vraag 22-10): zonder Men's/Women's en zonder "with ...";
     begint de titel met een kleur van het product, dan de gekozen kleur. */
  function korteNaam(p, kleur) {
    var t = String(p.title || '').replace(/^(men|women)['\u2019]s\s+/i, '').replace(/\s+(with|in)\s+.*$/i, '');
    var plek = kleurPlek(p);
    if (plek && kleur) ((p.options[plek - 1] || {}).values || []).forEach(function (v) {
      if (t.toLowerCase().indexOf(String(v).toLowerCase() + ' ') === 0) t = kleur + t.slice(String(v).length);
    });
    return t;
  }
  function kaart(h, kleur) {
    var doos = el('div', 'dc-kaart dc-kaart--koop');
    var a = el('a', 'dc-kaart-link'); a.href = '/products/' + h;
    var img = el('img'); img.alt = ''; img.width = 80; img.height = 100; img.loading = 'lazy';
    var t = el('div', 'dc-kaart-tekst'), naam = el('b', null, h.replace(/-/g, ' ')), prijs = el('span');
    t.appendChild(naam); t.appendChild(prijs); t.appendChild(el('small', null, 'Tap the photo to view'));
    a.appendChild(img); a.appendChild(t); doos.appendChild(a);
    var vul = function (p) {
      if (!p) return;
      var k = kleurVan(p, kleur), plek = kleurPlek(p);
      var vs = (p.variants || []).filter(function (v) { return v.available && (!plek || v['option' + plek] === k); });
      if (!doos.querySelector('.dc-koop')) { var rij = koopRij(vs, maatPlek(p)); if (rij) doos.appendChild(rij); }
      /* De foto opent de variant die in de keuzelijst staat, dus de geadviseerde maat
         (22-10, chat wcb596: de link ging naar de eerste variant en daar stond S). */
      var keus = doos.querySelector('.dc-koop select');
      var naarVariant = function () { var id = keus ? keus.value : (vs[0] && vs[0].id); if (id) a.href = '/products/' + h + '?variant=' + id; };
      naarVariant();
      if (keus && !keus.dataset.link) { keus.dataset.link = '1'; keus.addEventListener('change', naarVariant); }
      naam.textContent = korteNaam(p, k);
      prijs.textContent = '\u00a3' + ((vs[0] ? vs[0].price : p.price) / 100).toFixed(2);
      var src = (vs[0] && vs[0].featured_image && vs[0].featured_image.src) || p.featured_image || (p.images && p.images[0]);
      if (src) img.src = (src.indexOf('//') === 0 ? 'https:' + src : src) + (src.indexOf('?') < 0 ? '?width=240' : '&width=240');
      img.alt = p.title + (k ? ', ' + k : '');
    };
    if (producten[h] && producten[h].then) producten[h].then(vul); else vul(producten[h]);
    if (!producten[h]) producten[h] = fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { producten[h] = p; vul(p); return p; }).catch(function () { return null; });
    return doos;
  }

  /* ---- in de tas (22-10, zijn vraag) ---------------------------------------
     Adviseert de bot een maat voor het product van deze pagina (b.tas), dan
     legt de widget die meteen in de tas, in de kleur die op de pagina gekozen
     is; de bot zegt dat in zijn bericht en eronder staat Remove. Alleen een
     nieuw bericht (hooguit 2 min oud) en elk bericht één keer: een herlaadde
     pagina legt niets opnieuw in de tas. Het tweede stuk komt NOOIT vanzelf in
     de tas: dat is een kaart met maatkeuze (de geadviseerde maat staat al
     klaar) en een knop. Het thema ververst teller en lade met getCart() van
     <cart-items> (theme.dev.js); die opent de lade ook, dus terwijl de chat
     open is houden we dat ene "product toegevoegd" tegen. */
  var inTas = {};
  try { inTas = JSON.parse(opslag('sessionStorage', 'draycott-chat-intas') || '{}') || {}; } catch (e) {}
  function bewaarInTas() { opslag('sessionStorage', 'draycott-chat-intas', JSON.stringify(inTas)); }
  function product(h) {
    if (producten[h] && !producten[h].then) return Promise.resolve(producten[h]);
    return producten[h] || (producten[h] = fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { producten[h] = p; return p; }).catch(function () { return null; }));
  }
  function maatPlek(p) {
    var namen = (p.options || []).map(function (o) { return String(o && o.name || o).toLowerCase(); });
    return namen.indexOf('size') + 1;
  }
  function verversTas() {
    var ci = document.querySelector('cart-items');
    if (!ci || typeof ci.getCart !== 'function') return;
    if (open) {
      var stop = function (e) { e.stopImmediatePropagation(); window.removeEventListener('theme:product:added', stop, true); };
      window.addEventListener('theme:product:added', stop, true);
      setTimeout(function () { window.removeEventListener('theme:product:added', stop, true); }, 8000);
    }
    try { ci.getCart(); } catch (e) {}
  }
  function inDeTas(variant) {
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { verversTas(); return (d.items && d.items[0]) || d; });
  }
  function haalUitTas(key) {
    return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }) })
      .then(function (x) { if (!x.ok) throw new Error(x.status); });
  }
  /* Wat de knop op een kaart in de tas legde (variant -> regelsleutel). Staat in
     sessionStorage en niet in de kaart zelf: tekenLijst() bouwt kaarten opnieuw
     op, en de knop moet dan weer Remove zeggen. Ook tasWeg heeft deze lijst nodig. */
  var kaartTas = {};
  try { kaartTas = JSON.parse(opslag('sessionStorage', 'draycott-chat-kaarttas') || '{}') || {}; } catch (e) {}
  function bewaarKaartTas() { opslag('sessionStorage', 'draycott-chat-kaarttas', JSON.stringify(kaartTas)); }
  /* De bot hoorde de klant vragen het weg te halen (tasWeg): alles wat de chat
     in dit gesprek in de tas legde en er nog in zit, gaat eruit. Alleen een nieuw
     teambericht en elk bericht één keer, net als legInTas. */
  function haalWegGedaan(n) {
    try { return (JSON.parse(opslag('sessionStorage', 'draycott-chat-tasweg') || '[]') || []).indexOf(n) >= 0; } catch (e) { return false; }
  }
  function haalWeg(b) {
    if (!b.tasWeg || Date.now() - Date.parse(b.op) > 120000) return;
    var gedaan = []; try { gedaan = JSON.parse(opslag('sessionStorage', 'draycott-chat-tasweg') || '[]') || []; } catch (e) {}
    if (gedaan.indexOf(b.n) >= 0) return;
    gedaan.push(b.n); opslag('sessionStorage', 'draycott-chat-tasweg', JSON.stringify(gedaan));
    var sleutels = [];
    Object.keys(inTas).forEach(function (n) { var t = inTas[n]; if (t && t.key && !t.weg) { sleutels.push(t.key); t.weg = true; } });
    Object.keys(kaartTas).forEach(function (v) { sleutels.push(kaartTas[v]); });
    kaartTas = {}; bewaarKaartTas(); bewaarInTas();
    Promise.all(sleutels.map(function (k) { return haalUitTas(k).catch(function () {}); })).then(function () {
      if (sleutels.length) verversTas();
      getekend = ''; if (open) tekenLijst();
    });
  }
  function tasRegel(n) {
    var t = inTas[n], r = el('div', 'dc-intas');
    if (t.bezig) { r.textContent = 'Adding it to your bag...'; return r; }
    if (t.fout) { r.textContent = 'I couldn\u2019t add it to your bag. Please choose size ' + t.maat + ' on the page.'; return r; }
    if (t.weg) { r.textContent = 'Removed from your bag.'; return r; }
    r.appendChild(el('span', null, '\u2713 In your bag: size ' + t.maat));
    var weg = el('button', null, 'Remove'); weg.type = 'button';
    weg.addEventListener('click', function () {
      weg.disabled = true;
      haalUitTas(t.key)
        .then(function () { t.weg = true; bewaarInTas(); verversTas(); tekenLijst(); })
        .catch(function () { weg.disabled = false; });
    });
    r.appendChild(weg);
    return r;
  }
  // De variant die de klant op de productpagina gekozen heeft (zelfde veld als legInTas); anders niets.
  function paginaVariant() {
    var veld = location.pathname.indexOf('/products/') >= 0 && document.querySelector('form[action*="/cart/add"] [name="id"]');
    var n = veld ? parseInt(veld.value, 10) : 0;
    return n > 0 ? n : 0;
  }
  function legInTas(b) {
    if (!b.tas || inTas[b.n] || Date.now() - Date.parse(b.op) > 120000) return;
    if (location.pathname.split('/products/')[1] !== b.tas.handle && location.pathname.split('/products/')[1] !== b.tas.handle + '/') return;
    inTas[b.n] = { maat: b.tas.maat, bezig: true }; bewaarInTas();
    opslag('localStorage', 'draycott-chat-maat', b.tas.maat);
    product(b.tas.handle).then(function (p) {
      var plek = p && maatPlek(p);
      if (!plek) throw new Error('geen maat');
      // De kleur die op de pagina gekozen is; anders de eerste leverbare in die maat.
      var veld = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var nu = veld && p.variants.filter(function (v) { return String(v.id) === String(veld.value); })[0];
      var past = p.variants.filter(function (v) { return v.available && v['option' + plek] === b.tas.maat; });
      var v = (nu && past.filter(function (x) { return [1, 2, 3].every(function (i) { return i === plek || x['option' + i] === nu['option' + i]; }); })[0]) || past[0];
      if (!v) throw new Error('niet leverbaar');
      return inDeTas(v.id);
    }).then(function (regel) {
      inTas[b.n] = { maat: b.tas.maat, key: regel.key || regel.id };
      meet('intas');
    }).catch(function () {
      inTas[b.n] = { maat: b.tas.maat, fout: true };
    }).then(function () { bewaarInTas(); tekenLijst(); });
  }
  /* De koop-rij op een kaart: alleen de maten van de getoonde kleur (zijn keuze
     22-10: geen kleuren in de lijst); de geadviseerde maat staat klaar. */
  function koopRij(vs, plek) {
    if (!vs.length) return null;
    var rij = el('div', 'dc-koop'), keus = el('select'), knop = el('button', null, 'Add to bag');
    keus.setAttribute('aria-label', 'Size'); knop.type = 'button';
    var maat = opslag('localStorage', 'draycott-chat-maat');
    vs.forEach(function (v) {
      var label = plek ? v['option' + plek] : v.title;
      var o = el('option', null, label); o.value = v.id;
      if (label === maat) o.selected = true;
      keus.appendChild(o);
    });
    // De knop volgt de gekozen maat: staat die al in de tas dan is het Remove, anders Add to bag.
    var zet = function () {
      var erin = !!kaartTas[keus.value];
      knop.disabled = false; knop.textContent = erin ? 'Remove' : 'Add to bag'; knop.className = erin ? 'dc-weg' : '';
    };
    zet();
    keus.addEventListener('change', zet);
    knop.addEventListener('click', function () {
      var v = keus.value;
      knop.disabled = true;
      if (kaartTas[v]) {
        knop.textContent = 'Removing...';
        haalUitTas(kaartTas[v]).then(function () { delete kaartTas[v]; bewaarKaartTas(); verversTas(); zet(); })
          .catch(zet);
        return;
      }
      knop.textContent = 'Adding...';
      inDeTas(Number(v)).then(function (regel) { kaartTas[v] = regel.key || regel.id; bewaarKaartTas(); zet(); meet('kaartintas'); })
        .catch(zet);
    });
    rij.appendChild(keus); rij.appendChild(knop);
    return rij;
  }

  function wachtOpAgent() {
    // Alleen wat na het laatste "Chat ended" kwam telt.
    var na = berichten.slice(berichten.map(function (b) { return b.van; }).lastIndexOf('systeem') + 1);
    return st.online && !st.joined && !st.mens && na.some(function (b) { return b.van === 'klant'; });
  }
  // Offline (buiten de tijden van het rooster op /chat) met een vraag die nog geen antwoord heeft.
  function offlineVraag() {
    var na = berichten.slice(berichten.map(function (b) { return b.van; }).lastIndexOf('systeem') + 1);
    return !st.online && !st.mens && na.some(function (b) { return b.van === 'klant'; }) && !na.some(function (b) { return b.van === 'team'; });
  }

  /* ---- netwerk ------------------------------------------------------------ */
  /* Met het paneel open en een vraag die nog open staat elke 1,5 s: de typfase
     duurt minstens 3 s en valt er dus niet tussendoor. De server staat 90 per
     minuut toe. */
  function plan() {
    clearTimeout(timer);
    if (document.visibilityState !== 'visible') return;
    var wacht = berichten.length && berichten[berichten.length - 1].van === 'klant';
    timer = setTimeout(haal, open ? (wacht || st.typt ? 1500 : 3000) : (id ? 30000 : 60000));
  }
  function haal() {
    var q = id ? '?id=' + encodeURIComponent(id) + '&na=' + na : '';
    /* Een fout of 429 ("te vaak") laat de vorige stand staan. Eerst las de widget
       die als leeg antwoord: niemand binnen, bot uit, en dan stond de wachtrij met
       het e-mailveld er weer (21-10). */
    return fetch(BASIS + '/chat/gesprek' + q, { cache: 'no-store' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).then(function (d) {
      st.online = !!d.online; st.team = d.team || null; st.ai = !!d.ai; st.tijden = d.tijden || null;
      opslag('sessionStorage', 'draycott-chat-online', JSON.stringify({ t: Date.now(), online: st.online, team: st.team, ai: st.ai }));
      var hadIets = berichten.length > 0;
      if (id) {
        st.avatar = d.avatar || st.avatar; st.mens = !!d.mens; st.typt = d.typt || null; st.joined = !!d.joined;
        (d.berichten || []).forEach(function (b) {
          if (b.n <= na) return;
          na = b.n;
          // Het eigen bericht stond er al als voorlopig; nu vervangen door de echte.
          if (b.van === 'klant') { for (var i = 0; i < berichten.length; i++) if (berichten[i].wacht && berichten[i].tekst === b.tekst) { berichten.splice(i, 1); break; } }
          // De openingszin van een trigger stond er al lokaal; nu komt hij van de server.
          if (b.van === 'team') { for (var j = 0; j < berichten.length; j++) if (berichten[j].lokaal && berichten[j].tekst === b.tekst) { berichten.splice(j, 1); break; } }
          berichten.push(b);
          if (b.tas) legInTas(b);
          if (b.tasWeg) haalWeg(b);
        });
      }
      /* Gesloten (door de eigenaar, of de bot na een vraag om een mens): wie het
         gesprek nu voor zich had, ziet het laatste bericht nog met "Chat ended";
         een volgend bericht begint een nieuw gesprek. Een oud gesloten gesprek
         van een eerder bezoek verdwijnt gewoon. */
      if (d.gesloten) {
        opslag('localStorage', 'draycott-chat-id', null); id = null; na = 0;
        st.avatar = null; st.mens = false; st.joined = false; st.typt = null;
        berichten = hadIets ? berichten.concat([{ van: 'systeem', tekst: 'Chat ended' }]) : [];
      }
      tekenKnop();
      if (open) { tekenKop(); tekenLijst(); }
    }).catch(function () {}).then(plan);
  }
  function verstuur(e) {
    if (e) e.preventDefault();
    var t = veld.value.trim();
    if (!t || bezig) return;
    if (!id) { id = nieuwId(); opslag('localStorage', 'draycott-chat-id', id); }
    var mail = (email.hidden ? '' : email.value.trim()) || ((t.match(EMAIL_RE) || [])[0] || '');
    if (mail) opslag('localStorage', 'draycott-chat-email', mail);
    var body = { id: id, tekst: t, pagina: location.pathname.slice(0, 300) };
    if (paginaVariant()) body.variant = paginaVariant();
    opslag('localStorage', 'draycott-chat-pagina', location.pathname);
    // Eerste bericht na een trigger: de server begint het gesprek met haar openingszin.
    if (voorzet && berichten.some(function (b) { return b.lokaal; })) body.voorzet = voorzet;
    if (mail) body.email = mail;
    var bz = bezoeker(); if (bz) body.bezoeker = bz;
    bezig = true; melding.textContent = '';
    berichten.push({ van: 'klant', tekst: t, wacht: true });
    veld.value = ''; stuurKnop.disabled = true; tekenLijst();
    lijst.scrollTop = lijst.scrollHeight;
    // Het aantal stuks in de tas gaat mee: de bot noemt dan de korting die echt geldt (22-10).
    tasStand().then(function (c) {
      if (c) { body.tas = c.tas; body.tasInhoud = c.tasInhoud; }
      return fetch(BASIS + '/chat/bericht', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status === 429 ? 'You are sending messages quickly; please wait a moment.' : 'Your message did not send. Please try again.');
        meet('bericht');
      })
      .catch(function (err) {
        berichten = berichten.filter(function (b) { return !(b.wacht && b.tekst === t); });
        veld.value = t; melding.textContent = err.message;
      })
      .then(function () { bezig = false; stuurKnop.disabled = !veld.value.trim(); tekenLijst(); haal(); });
  }

  /* De tas uit één /cart.js: aantal stuks (tas) en wat erin zit (tasInhoud, bedragen
     in pence), of null als /cart.js niet antwoordt. De bot noemt er de echte korting
     en het echte totaal mee. */
  function tasStand() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || typeof c.item_count !== 'number') return null;
        return { tas: c.item_count, tasInhoud: {
          totaal: Math.round(c.total_price || 0), korting: Math.round(c.total_discount || 0),
          regels: (c.items || []).slice(0, 10).map(function (i) {
            return { titel: String(i.product_title || '').slice(0, 120), variant: String(i.variant_title || '').slice(0, 120),
              aantal: i.quantity, prijs: Math.round(i.final_line_price || 0) };
          }) } };
      })
      .catch(function () { return null; });
  }

  /* ---- triggers (21-10) ---------------------------------------------------
     De chat spreekt de klant zelf aan op drie twijfelmomenten, met een wolkje van
     een medewerker boven de knop:
       maatgids    maatgids geopend en daarna 12 s niets gedaan;
       maatkiezer  op "Select size" getikt en na 8 s nog geen maat gekozen;
       tas         iets in de tas en 20 s op de pagina, ook al scrolt hij (tas dicht,
                   niet tijdens typen), met de stapelkorting voor het volgende stuk;
       terug       na meer dan 30 min weg terugkomen met iets in de tas: meteen
                   (zodra de knop er is), met dezelfde stapelkorting;
       tijd        30 s op de site (over pagina's heen), alleen groep `tijd` van
                   de A/B-test hierboven.
     Hooguit een wolkje per sessie, niet als er al een gesprek is of de klant de
     chat zelf opende. Tik = paneel open met die zin als eerste bericht; de
     medewerker is dan al binnen (chat.mjs, voorzet). */
  var TEKSTEN = {
    maatgids: function () { return 'Need a hand with sizing? Tell me the measurement you usually go by and I\u2019ll match it to the guide.'; },
    maatkiezer: function () { return 'Stuck between two sizes? Tell me what you usually wear and I\u2019ll help you pick.'; },
    // 22-10, zijn keuze: een hulp- en adviesvraag, geen korting bij binnenkomst.
    terug: function () {
      return 'Welcome back. Can I help with anything, or give you some styling advice on what’s in your bag?';
    },
    /* Een open hulpvraag die past bij waar hij is, geen "Hi, how can I help?":
       een algemene groet wordt weggeklikt, een concreet aanbod (maat, combineren)
       niet. Geen korting: die komt pas als er iets in de tas zit. */
    tijd: function () {
      return /\/products\//.test(location.pathname)
        ? 'Any questions about this piece? I can help you pick your size or suggest what to wear it with.'
        : 'Looking for something in particular? I can point you to it or help with sizing.';
    },
    /* 22-10, zijn opmerking: met twee stuks in de tas loopt de 10% al; dan geen
       nieuw aanbod maar zeggen wat er al geldt en een open vraag. */
    tas: function (n) {
      return n === 1 ? 'Good choice. Add one more piece and your whole order is 10% off. Can I help you find something to go with it?'
        : n === 2 ? 'Nice picks, your 10% multi-buy discount is already on. Can I advise you on anything else?'
        : n === 3 ? 'Lovely choices, you’re already getting 20% off your whole order. Can I advise you on anything else?'
        : 'Lovely selection, you’re getting our full 25% off. Can I advise you on anything else before you check out?';
    }
  };
  var wolk = el('div', 'dc-wolk'); wolk.hidden = true; wolk.setAttribute('role', 'status');
  var wolkOpen = el('button', 'dc-wolk-open'); wolkOpen.type = 'button';
  var wolkDicht = el('button', 'dc-wolk-dicht', '\u00d7'); wolkDicht.type = 'button'; wolkDicht.setAttribute('aria-label', 'Dismiss');
  wolk.appendChild(wolkOpen); wolk.appendChild(wolkDicht);
  var voorzet = null, wolkTrigger = null, wolkTimer = null, stil = Date.now(), gekozen = 0;

  function magVoorzet(trigger) {
    // Buiten de live-tijden van het rooster op /chat spreekt de chat niemand aan.
    if (!gestart || open || id || !st.online || !knop.classList.contains('dc-toon')) return false;
    if (opslag('sessionStorage', 'draycott-chat-voorzet') || opslag('sessionStorage', 'draycott-chat-zelf')) return false;
    // De tas ligt als laag over de pagina: dan niet storen, wachten tot hij dicht is.
    return (trigger !== 'tas' && trigger !== 'tijd') || !document.documentElement.hasAttribute('data-scroll-locked');
  }
  function toonVoorzet(trigger, tekst) {
    if (!magVoorzet(trigger)) return;
    opslag('sessionStorage', 'draycott-chat-voorzet', trigger);
    var t = team(), a = t[Math.floor(Math.random() * t.length)];
    voorzet = { tekst: tekst, naam: a.naam, foto: a.foto, trigger: trigger };
    toonWolk(trigger, tekst, a);
  }
  /* De maatkiezer is een <dialog> die met showModal() opent: dat ligt in de top layer,
     boven elke z-index, en maakt de rest van de pagina inert. Het wolkje in body valt
     er dus achter en is niet aan te tikken. Daarom hangt het tijdens de sheet ín de
     dialog, bovenaan het scherm. */
  function wolkPlaats() {
    var d = document.querySelector('dialog.maatkiezer[open]');
    if (d) { d.appendChild(wolk); wolk.classList.add('dc-wolk-boven'); }
    else { document.body.appendChild(wolk); wolk.classList.remove('dc-wolk-boven'); }
  }
  function toonWolk(trigger, tekst, a) {
    wolkTrigger = trigger;
    wolkPlaats();
    wolkOpen.textContent = '';
    wolkOpen.appendChild(gezicht(a.foto));
    var w = el('span'); w.appendChild(el('b', null, a.naam)); w.appendChild(document.createTextNode(tekst));
    wolkOpen.appendChild(w);
    wolk.hidden = false;
    meet('voorzet', trigger);
    clearTimeout(wolkTimer); wolkTimer = setTimeout(function () { wolk.hidden = true; }, 30000);
  }
  function openViaWolk() {
    wolk.hidden = true; clearTimeout(wolkTimer);
    // Open maatkiezer = modale dialog boven alles: eerst dicht, anders opent de chat erachter.
    var sheet = document.querySelector('dialog.maatkiezer[open]');
    if (sheet) { try { sheet.close(); } catch (e) {} wolkPlaats(); }
    if (wolkTrigger) meet('voorzetklik', wolkTrigger);
    if (voorzet) {
      st.avatar = { naam: voorzet.naam, foto: voorzet.foto }; st.joined = true;
      berichten = [{ van: 'team', tekst: voorzet.tekst, naam: voorzet.naam, foto: voorzet.foto, lokaal: true }];
    }
    zetOpen(true);
  }
  wolkOpen.addEventListener('click', openViaWolk);
  wolkDicht.addEventListener('click', function () { wolk.hidden = true; voorzet = null; clearTimeout(wolkTimer); });

  // Stil = geen scroll, tik of toets. Elke beweging zet de klok terug.
  ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
    window.addEventListener(ev, function () { stil = Date.now(); }, { passive: true, capture: true });
  });
  /* Wacht `ms` stilte en kijk dan of het moment er nog is (`nog`). */
  function naStilte(trigger, ms, nog) {
    var vanaf = Date.now();
    (function kijk() {
      if (!magVoorzet(trigger) || !nog()) return;
      var rust = Date.now() - Math.max(stil, vanaf);
      if (rust >= ms) toonVoorzet(trigger, TEKSTEN[trigger]());
      else setTimeout(kijk, ms - rust + 50);
    })();
  }
  /* De maatkiezer-sheet herkennen aan de dialog zelf, niet aan de knoptekst: op de
     winkel opent hij via "ADD TO CART" zonder gekozen maat. Na 8 s open zonder maat
     het wolkje; sluit de sheet, dan gaat het wolkje terug naar zijn gewone plek. */
  new MutationObserver(function (lijst) {
    lijst.forEach(function (m) {
      var d = m.target;
      if (!d.matches || !d.matches('dialog.maatkiezer')) return;
      if (!d.hasAttribute('open')) { if (wolk.parentNode === d) wolkPlaats(); return; }
      var voor = gekozen;
      setTimeout(function () {
        if (d.hasAttribute('open') && gekozen === voor && magVoorzet('maatkiezer')) toonVoorzet('maatkiezer', TEKSTEN.maatkiezer());
      }, 8000);
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
  // Een maat gekozen = een wijziging in het productformulier.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"], [data-product-form], product-form, variant-selects, variant-radios')) gekozen++;
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('a,button,summary,label,[role=button],[data-maatwijzer-open]') : null;
    if (!t || knop.contains(t) || paneel.contains(t) || wolk.contains(t)) return;
    var tekst = (t.innerText || t.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim().slice(0, 60);
    var spoor = (t.getAttribute('href') || '') + ' ' + (typeof t.className === 'string' ? t.className : '');
    if (t.hasAttribute('data-maatwijzer-open') || /size\s*(guide|chart)|find my size|sizing/i.test(tekst) || /size-guide|size_chart|kiwi/i.test(spoor)) {
      setTimeout(function () { stil = Date.now(); naStilte('maatgids', 12000, function () { return true; }); }, 0);
    } else if (/select (a )?size|choose (a )?size/i.test(tekst)) {
      var voor = gekozen;
      setTimeout(function () { stil = Date.now(); naStilte('maatkiezer', 8000, function () { return gekozen === voor; }); }, 0);
    }
  }, true);
  /* De tas: 20 s nadat de klant met iets in de tas op een pagina is, of iets in de tas
     deed (theme:product:added), ook als hij scrolt. Geen stilte, want met iets in de
     tas is scrollen gewoon kijken. Niet met de tas of een sheet open
     (data-scroll-locked, via magVoorzet) en niet terwijl hij typt. /cart.js hooguit
     eens per 15 s. */
  var tasSinds = Date.now(), tasGevraagd = 0;
  document.addEventListener('theme:product:added', function () { tasSinds = Date.now(); });
  setInterval(function () {
    var a = document.activeElement;
    if (!magVoorzet('tas') || Date.now() - tasSinds < 20000 || Date.now() - tasGevraagd < 15000) return;
    if (a && !paneel.contains(a) && /^(input|textarea|select)$/i.test(a.tagName || '') || (a && a.isContentEditable)) return;
    tasGevraagd = Date.now();
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (c && c.item_count > 0) toonVoorzet('tas', TEKSTEN.tas(c.item_count));
    }).catch(function () {});
  }, 5000);

  /* Terugkomer met een gevulde tas: de tas hangt aan een cookie, dus /cart.js
     weet het ook na dagen. "Terug" = het vorige paginabezoek was meer dan 30 min
     geleden. Wacht tot de knop er is (10 s buiten productpagina's); magVoorzet
     weigert als er al een wolkje was of de chat zelf geopend werd. */
  (function () {
    var nu = Date.now(), laatst = parseInt(opslag('localStorage', 'draycott-chat-bezocht') || '0', 10);
    opslag('localStorage', 'draycott-chat-bezocht', String(nu));
    if (!laatst || nu - laatst < 30 * 60000) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c || !(c.item_count > 0)) return;
      var poging = 0, t = setInterval(function () {
        if (++poging > 40 || opslag('sessionStorage', 'draycott-chat-voorzet')) return clearInterval(t);
        toonVoorzet('terug', TEKSTEN.terug(c.item_count));
      }, 1000);
    }).catch(function () {});
  })();

  /* 30 s op de site: de klok loopt per sessie (sessionStorage), dus ook over
     paginawissels heen. Kan het wolkje op dat moment niet (tas of sheet open,
     typen, knop nog niet in beeld), dan elke 5 s opnieuw kijken; magVoorzet
     stopt alles zodra er deze sessie al een wolkje was of hij zelf opende. */
  if (AB === 'tijd') {
    var sinds = parseInt(opslag('sessionStorage', 'draycott-chat-sinds') || '0', 10);
    if (!sinds) { sinds = Date.now(); opslag('sessionStorage', 'draycott-chat-sinds', String(sinds)); }
    setTimeout(function probeer() {
      if (opslag('sessionStorage', 'draycott-chat-voorzet') || opslag('sessionStorage', 'draycott-chat-zelf') || id) return;
      var a = document.activeElement;
      var typt = a && !paneel.contains(a) && (/^(input|textarea|select)$/i.test(a.tagName || '') || a.isContentEditable);
      if (!typt && magVoorzet('tijd')) return toonVoorzet('tijd', TEKSTEN.tijd());
      setTimeout(probeer, 5000);
    }, Math.max(0, sinds + 30000 - Date.now()));
  }

  /* ---- vervolg na een gesprek (22-10, zijn vraag) -------------------------
     De klant chatte, sloot het venster en kijkt verder. Is het venster 45 s
     dicht en toont hij opnieuw interesse, dan stuurt de bot uit zichzelf één
     bericht als stijladviseur, met wat erbij past (chatantwoord.py, VERDER):
       ander product  een productpagina die niet die van het gesprek is, 20 s;
       tas            iets in de tas gedaan; dan ook de stapelkorting.
     Alleen als het laatste woord van ons was en de bot het gesprek heeft. Eén
     keer per gesprek, hier en op de server (verderStart in chat.mjs). Het
     bericht staat al in het gesprek; het wolkje toont alleen het begin, de
     productkaarten komen in het paneel. */
  var DICHT_MS = 45000, OP_PRODUCT_MS = 20000;
  window.addEventListener('pagehide', function () { if (open && id) opslag('localStorage', 'draycott-chat-dicht', String(Date.now())); });
  if (id && !opslag('localStorage', 'draycott-chat-dicht')) opslag('localStorage', 'draycott-chat-dicht', String(Date.now()));
  function magVerder() {
    if (!gestart || open || !id || !st.online || !st.ai || st.mens || !knop.classList.contains('dc-toon')) return false;
    if (opslag('localStorage', 'draycott-chat-verder') === id) return false;
    var laatst = berichten[berichten.length - 1];
    if (!laatst || laatst.van !== 'team') return false;
    return Date.now() - parseInt(opslag('localStorage', 'draycott-chat-dicht') || '0', 10) >= DICHT_MS;
  }
  // toegevoegd: de klant deed net iets in de tas; het aantal komt altijd mee.
  function vraagVerder(toegevoegd) {
    opslag('localStorage', 'draycott-chat-verder', id);
    var body = { id: id, pagina: location.pathname.slice(0, 300) };
    if (paginaVariant()) body.variant = paginaVariant();
    if (toegevoegd) body.toegevoegd = true;
    tasStand().then(function (c) {
      if (c) { body.tas = c.tas; body.tasInhoud = c.tasInhoud; }
      return fetch(BASIS + '/chat/verder', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    })
      .then(function (r) { return r.status === 200 ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.tekst || open) return;
        // Links worden in het paneel productkaarten; het wolkje krijgt de eerste zinnen.
        var zinnen = d.tekst.split(/https?:\/\//)[0].replace(/\*\*/g, '').match(/[^.!?]+[.!?]+/g) || [d.tekst];
        var kort = zinnen[0].trim();
        for (var i = 1; i < zinnen.length && (kort + zinnen[i]).length <= 170; i++) kort += zinnen[i];
        toonWolk('verder', kort.trim(), { naam: d.naam, foto: d.foto });
        haal();
      }).catch(function () {});
  }
  var opPagina = Date.now(), tasErbij = false;
  var anderProduct = /\/products\//.test(location.pathname) && location.pathname !== opslag('localStorage', 'draycott-chat-pagina');
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('button,[type=submit]') : null;
    if (!t || knop.contains(t) || paneel.contains(t) || wolk.contains(t)) return;
    // Na 1,5 s: dan heeft het thema de tas bijgewerkt en klopt /cart.js.
    if (/add to (bag|cart|basket)/i.test(t.innerText || t.value || '')) setTimeout(function () { tasErbij = true; }, 1500);
  }, true);
  var verderLus = setInterval(function () {
    if (Date.now() - opPagina > 600000 || (id && opslag('localStorage', 'draycott-chat-verder') === id)) return clearInterval(verderLus);
    if (!magVerder()) return;
    if (tasErbij) {
      tasErbij = false;
      vraagVerder(true);
    } else if (anderProduct && Date.now() - opPagina >= OP_PRODUCT_MS) vraagVerder(false);
  }, 2000);

  /* ---- open en dicht ------------------------------------------------------ */
  /* Android Chrome en Firefox leggen het toetsenbord standaard als laag over de
     pagina; met interactive-widget=resizes-content krimpt de pagina zelf, en
     dan zakt het paneel (top 0, bottom 0) vanzelf mee tot boven het
     toetsenbord. Alleen zolang het paneel open is, daarna de oude meta terug.
     iOS kent dit niet en blijft op volg() hieronder leunen. */
  var meta = document.querySelector('meta[name="viewport"]');
  var metaOud = meta ? meta.getAttribute('content') : null;
  function zetMeta(aan) {
    if (!meta || metaOud == null) return;
    meta.setAttribute('content', aan ? metaOud.replace(/,?\s*interactive-widget=[^,]*/, '') + ', interactive-widget=resizes-content' : metaOud);
  }
  function zetOpen(aan, viaTerug) {
    if (open === aan) return;
    open = aan;
    if (klein()) zetMeta(aan);
    if (!aan) zetMeta(false);
    volg();
    paneel.hidden = !aan;
    document.documentElement.classList.toggle('dc-open', aan);
    if (aan) {
      meet('geopend');
      // Zelf geopend (niet via een wolkje): deze sessie geen wolkjes meer.
      if (!voorzet) opslag('sessionStorage', 'draycott-chat-zelf', '1');
      wolk.hidden = true;
      // Android: de terugveeg sluit het paneel en niet de pagina.
      try { history.pushState({ dcChat: 1 }, ''); } catch (e) {}
      tekenKop(); tekenLijst();
      lijst.scrollTop = lijst.scrollHeight;
      if (window.matchMedia('(min-width: 641px)').matches) veld.focus();
      haal();
    } else {
      if (id) opslag('localStorage', 'draycott-chat-dicht', String(Date.now()));
      if (!viaTerug && history.state && history.state.dcChat) { try { history.back(); } catch (e) {} }
      knop.focus();
      plan();
    }
  }
  knop.addEventListener('click', function () { if (!wolk.hidden) return openViaWolk(); zetOpen(true); });
  dicht.addEventListener('click', function () { zetOpen(false); });
  window.addEventListener('popstate', function () { if (open) zetOpen(false, true); });
  document.addEventListener('keydown', function (e) { if (open && e.key === 'Escape') zetOpen(false); });
  vak.addEventListener('submit', verstuur);
  // Send pakt geen focus, anders klapt het toetsenbord op mobiel dicht en weer open.
  stuurKnop.addEventListener('pointerdown', function (e) { e.preventDefault(); });
  veld.addEventListener('input', function () { stuurKnop.disabled = !veld.value.trim() || bezig; });
  veld.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) verstuur(e); });

  /* Mobiel: het paneel volgt het zichtbare deel (visualViewport), zodat een
     toetsenbord dat als laag over de pagina ligt (iOS, of Android zonder
     resizes-content) het invoerveld niet bedekt. Ook na focus nog twee keer
     meten: niet elke browser vuurt resize pas als het toetsenbord stilstaat. */
  function klein() { return window.matchMedia('(max-width: 640px)').matches; }
  function volg() {
    var vv = window.visualViewport;
    if (!open || !klein() || !vv) { paneel.style.height = paneel.style.top = ''; return; }
    paneel.style.top = vv.offsetTop + 'px';
    paneel.style.height = vv.height + 'px';
    lijst.scrollTop = lijst.scrollHeight;
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', volg);
    window.visualViewport.addEventListener('scroll', volg);
  }
  window.addEventListener('resize', volg);
  veld.addEventListener('focus', function () { setTimeout(volg, 300); setTimeout(volg, 700); });

  /* Boven de sticky Add to cart (#cart-bar), en kleiner bij omlaag scrollen:
     dan staan alleen de gezichten er nog. */
  var vorigeY = window.scrollY, gepland = false;
  function schik() {
    gepland = false;
    var y = window.scrollY;
    if (Math.abs(y - vorigeY) > 8) { knop.classList.toggle('dc-klein', y > vorigeY && y > 200); vorigeY = y; }
    var cb = document.getElementById('cart-bar'), onder = 0;
    if (cb) { var r = cb.getBoundingClientRect(); if (r.height && r.top < window.innerHeight) onder = Math.max(0, window.innerHeight - r.top); }
    knop.style.setProperty('--dc-onder', onder + 'px');
    wolk.style.setProperty('--dc-onder', onder + 'px');
  }
  /* De sticky balk schuift na het scrollen pas binnen (animatie); daarom na het
     scrollen nog een keer meten, anders ligt het gezicht over Select size. */
  var naScroll = null;
  window.addEventListener('scroll', function () {
    if (!gepland) { gepland = true; requestAnimationFrame(schik); }
    clearTimeout(naScroll); naScroll = setTimeout(schik, 450);
  }, { passive: true });
  window.addEventListener('resize', schik);
  var gestart = false;
  document.addEventListener('visibilitychange', function () { if (!gestart) return; if (document.visibilityState === 'visible') haal(); else clearTimeout(timer); });

  /* Pas na het volledig laden van de pagina doet de widget iets: CSS, knop,
     gezichten en de eerste netwerkvraag. Daarvoor hield hij Shopify's
     cookiebanner op (21-10). De knop verschijnt 10 s na het begin van de
     pagina (zijn keuze); wie al een gesprek heeft, ziet hem meteen. */
  function start() {
    if (gestart) return;
    gestart = true;
    document.head.appendChild(css);
    document.body.appendChild(knop);
    document.body.appendChild(paneel);
    document.body.appendChild(wolk);
    tekenKnop(); schik();
    haal();
    setTimeout(function () { knop.classList.add('dc-toon'); meet('getoond'); }, id ? 0 : Math.max(0, TOON_NA_MS - performance.now()));
  }
  if (document.readyState === 'complete') setTimeout(start, 0);
  else window.addEventListener('load', function () { setTimeout(start, 0); });
})();
